export const Blogs = [

{
    id: 1,
    name: "LeetCode Coding Profile – Data Structures & Algorithms Practice",
    tags: ["algorithmic-thinking","data-structures","competitive-coding","complexity-analysis"],
    date: "Live Stats",
    imgSrc: "https://leetcard.jacoblin.cool/Raja_retnam?theme=dark&font=Noto%20Sans%20New%20Tai%20Lue&ext=heatmap",
    link: "https://leetcode.com/u/Raja_retnam/"
},

{
    id: 2,
    name: "AWS Academy Graduate – AWS Academy Cloud Foundations",
    tags: ["cloud-architecture","aws-core-services","infrastructure-basics"],
    date: "27 Jan, 2025",
    imgSrc: "/aws.jpeg",
    link: "https://drive.google.com/file/d/1VqTAQ9Gtgi4OIve3n2VE3jSREFfrfkHc/view?usp=drive_link"
},

{
    id: 5,
    name: "Python for Data Science, AI – IBM (Coursera)",
    tags: ["data-processing","ai-foundations","python-ecosystem"],
    date: "10 Apr, 2025",
    imgSrc: "/Ai.jpeg",
    link: "https://drive.google.com/file/d/1nF4Xg5KeJRC28mAr_Q6Pf822Kj8RfTGD/view?usp=drive_link"
},

{
    id: 8,
    name: "SQL: A Practical Introduction for Querying Databases – IBM (Coursera)",
    tags: ["relational-modeling","query-optimization","structured-query-language"],
    date: "29 Apr, 2025",
    imgSrc: "/SQL.png",
    link: "https://drive.google.com/file/d/1funUbUgMUNvYPde0vx45Ib8YT0HbjBu5/view?usp=drive_link"
},

{
    id: 6,
    name: "Introduction to Front-End Development – Meta (Coursera)",
    tags: ["ui-engineering","javascript-fundamentals"],
    date: "25 Jul, 2025",
    imgSrc: "/IBM-FD.png",
    link: "https://drive.google.com/file/d/1z9erkUVVyZgPUJEwZS8NeiqLpTyjLDCj/view?usp=drive_link"
},

{
    id: 4,
    name: "30 Days MasterClass in Full Stack Development – NoviTech R&D",
    tags: ["api-integration","backend-basics","deployment-workflow"],
    date: "28 Feb, 2025",
    imgSrc: "/novitech.jpeg",
    link: "https://drive.google.com/file/d/1aLbYNoND8z9v-XM5FHyb8DXrBb_W-6SG/view?usp=drive_link"
},

{
    id: 3,
    name: "Web Development – EduSkills Academy",
    tags: ["web-fundamentals","frontend-structure","client-side-development"],
    date: "6 June, 2025",
    imgSrc: "/eduSkill.jpeg",
    link: "https://drive.google.com/file/d/1NCd7f0htNdv1XLMFID3WjS_8OHRd6K3Z/view?usp=drive_link"
},

{
    id: 7,
    name: "The Merge Sort Algorithm – Scrimba (Coursera)",
    tags: ["divide-and-conquer","sorting-techniques","time-complexity"],
    date: "29 Apr, 2025",
    imgSrc: "/DAA-MergeSort.png",
    link: "https://drive.google.com/file/d/1q3z0lFClp_yWlGf2xF6YT8Y3Q_rp1RhX/view?usp=drive_link"
}

]